import React, { useEffect, useState } from 'react';

// 学生の端末の確認（DeviceCheck）と「要注意にする／外す」【2026-10-01】
//   Apple の DeviceCheck は、その端末から届いたトークンでしか印を書けない。
//   そのため、ここで押すと「依頼」を置いておき、次にその学生がアプリでログイン・打刻したときに書き込む。
//   要注意の端末からの打刻は、信頼度が下がり先生にアラートが届く。
export default function DeviceCheckPanel({ userId, label, onClose }) {
  const [data, setData]     = useState(null);
  const [reason, setReason] = useState('');
  const [busy, setBusy]     = useState(false);
  const [err, setErr]       = useState('');
  const [msg, setMsg]       = useState('');

  const auth = () => ({ Authorization: 'Bearer ' + localStorage.getItem('token') });

  const load = async () => {
    setErr('');
    try {
      const res = await fetch(`/api/students/${userId}/device-check`, { headers: auth() });
      const d = await res.json();
      if (!d.success) throw new Error(d.message || '取得に失敗しました');
      setData(d);
    } catch (e) { setErr(e.message); }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [userId]);

  const send = async (action) => {
    const words = { flag: 'この学生の端末を要注意にします', unflag: 'この学生の端末の要注意を外します', cancel: '待っている依頼を取り消します' };
    if (!window.confirm(`${words[action]}。よろしいですか？`)) return;
    setBusy(true); setErr(''); setMsg('');
    try {
      const res = await fetch(`/api/students/${userId}/device-flag`, {
        method: 'POST', headers: { ...auth(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ action, reason: reason.trim() || undefined }),
      });
      const d = await res.json();
      if (!d.success) throw new Error(d.message || '依頼に失敗しました');
      setMsg(d.message); setReason('');
      await load();
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };

  const fmt = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    return `${d.getMonth() + 1}/${d.getDate()} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
  };
  const state = !data ? '' : data.flagged === true ? '要注意' : data.flagged === false ? '印なし' : 'まだ確かめていない';
  const ACTION = { flag: '要注意にする', unflag: '要注意を外す' };

  return (
    <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, padding: '0.7rem 0.9rem', background: '#fff', margin: '0.5rem 0' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <strong>端末の確認</strong><span style={{ color: '#555' }}>{label}</span>
        {onClose && <button className="btn-secondary" style={{ marginLeft: 'auto', padding: '0.1rem 0.6rem' }} onClick={onClose}>閉じる</button>}
      </div>
      {err && <div style={{ color: '#ef4444', margin: '6px 0' }}>{err}</div>}
      {msg && <div style={{ color: '#15803d', margin: '6px 0' }}>{msg}</div>}
      {data && (
        <>
          {!data.deviceCheck.enabled && (
            <div style={{ fontSize: '0.8rem', color: '#92400e', margin: '4px 0' }}>
              サーバーで DeviceCheck が使える設定になっていないため、依頼しても端末には書き込まれません。
            </div>
          )}
          <div style={{ margin: '6px 0', fontSize: '0.9rem' }}>
            いまの印：<strong style={{ color: data.flagged ? '#b91c1c' : '#374151' }}>{state}</strong>
            {data.pending && (
              <span style={{ marginLeft: 8, color: '#92400e' }}>
                （「{ACTION[data.pending.action] || data.pending.action}」の依頼が、次の打刻・ログインを待っています
                {data.pending.requested_by_name ? `・依頼: ${data.pending.requested_by_name}` : ''}）
              </span>
            )}
          </div>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
            <input value={reason} onChange={e => setReason(e.target.value)} maxLength={200}
                   placeholder="理由（任意。例: 代理打刻の疑い）" style={{ flex: '1 1 220px' }} />
            <button disabled={busy} onClick={() => send('flag')} style={{ color: '#b91c1c' }}>要注意にする</button>
            <button className="btn-secondary" disabled={busy} onClick={() => send('unflag')}>要注意を外す</button>
            {data.pending && <button className="btn-secondary" disabled={busy} onClick={() => send('cancel')}>依頼を取り消す</button>}
          </div>
          <div style={{ fontSize: '0.8rem', color: '#666', marginTop: 8 }}>最近の確認（新しい順）</div>
          {data.logs.length === 0 ? (
            <div style={{ fontSize: '0.8rem', color: '#999' }}>まだ記録がありません（新しいアプリでログイン・打刻すると記録されます）</div>
          ) : (
            <table className="data-table" style={{ width: '100%', fontSize: '0.8rem' }}>
              <thead><tr><th>日時</th><th>操作</th><th>端末ID</th><th>印</th><th>メモ</th></tr></thead>
              <tbody>
                {data.logs.slice(0, 8).map((l, i) => (
                  <tr key={i}>
                    <td style={{ whiteSpace: 'nowrap' }}>{fmt(l.at)}</td>
                    <td>{l.event === 'login' ? 'ログイン' : l.event === 'attendance' ? '打刻' : l.event}</td>
                    <td style={{ fontFamily: 'monospace' }}>{l.deviceId ? l.deviceId.slice(0, 8) + '…' : '-'}</td>
                    <td>{l.bit1 ? '要注意' : l.bit1 === false ? '—' : '?'}</td>
                    <td>{[l.reused ? '入れ直し・別の端末IDで使われた端末' : '', l.error || ''].filter(Boolean).join(' / ')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      )}
    </div>
  );
}
